import React from "react";
import "./ReportMenu.css";
import {
  FaChartLine,
  FaUserPlus,
  FaRegCalendarCheck,
  FaTasks,
  FaBriefcase,
  FaBullhorn,
  FaUserFriends,
  FaLifeRing,
  FaDollarSign,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaBullseye,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import translations from "../../assets/locals/translations";

const ReportMenu = () => {
  const navigate = useNavigate();
  const currentLanguage = useSelector((state) => state.language.language);
  const t = translations[currentLanguage] || translations['en'];

  const reportSections = [
    {
      main: {
        name: t.taskreport || "Task Report",
        description: t.taskreportdesc || "Manage and track tasks",
        icon: <FaTasks className="report-icon" />,
      },
      subReports: [
        t.taskreport || "Task Report",
      ],
    },
    {
      main: {
        name: t.salesreport || "Sales Report",
        description: t.salesreportdesc || "Analyze sales performance",
        icon: <FaChartLine className="report-icon" />,
      },
      subReports: [
        t.dailysales || "Daily Sales",
        t.monthlysales || "Monthly Sales",
        t.customsales || "Custom Sales",
        t.annualsales || "Annual Sales",
      ],
    },
    {
      main: {
        name: t.trackingreport || "Tracking Report",
        description: t.trackingreportdesc || "Track progress and movements",
        icon: <FaMapMarkerAlt className="report-icon" />,
      },
      subReports: [
        t.dailytracking || "Daily Tracking",
        t.weeklytracking || "Weekly Tracking",
        t.monthlytracking || "Monthly Tracking"
      ],
    },
    {
      main: {
        name: t.activityreport || "Activity Report",
        description: t.activityreportdesc || "Monitor daily activities",
        icon: <FaRegCalendarCheck className="report-icon" />,
      },
      subReports: [
        t.dailyactivity || "Daily Activity",
        t.weeklyactivity || "Weekly Activity",
        t.monthlyactivity || "Monthly Activity"
      ],
    },
    {
      main: {
        name: t.leadreport || "Lead Report",
        description: t.leadreportdesc || "Track leads and conversions",
        icon: <FaUserPlus className="report-icon" />,
      },
      subReports: [
        t.newleads || "New Leads",
        t.convertedleads || "Converted Leads",
        t.customleadreport || "Custom Lead Report"
      ],
    },
    {
      main: {
        name: t.targetreport || "Target Report",
        description: t.targetreportdesc || "Monitor target achievement and progress",
        icon: <FaBullseye className="report-icon" />,
      },
      subReports: [
        t.weeklytargets || "Weekly Targets",
        t.monthlytargets || "Monthly Targets",
        t.annualtargets || "Annual Targets",
      ],
    },
    {
      main: {
        name: t.opportunityreport || "Opportunity Report",
        description: t.opportunityreportdesc || "View potential opportunities",
        icon: <FaBriefcase className="report-icon" />,
      },
      subReports: [
        t.openopportunities || "Open Opportunities",
        t.closedopportunities || "Closed Opportunities",
        t.customopportunity || "Custom Opportunity",
      ],
    },
    {
      main: {
        name: t.campaignreport || "Campaign Report",
        description: t.campaignreportdesc || "Assess campaign performance",
        icon: <FaBullhorn className="report-icon" />,
      },
      subReports: [
        t.emailcampaign || "Email Campaign",
        t.socialcampaign || "Social Campaign",
        t.customcampaign || "Custom Campaign"
      ],
    },
    {
      main: {
        name: t.customerreport || "Customer Report",
        description: t.customerreportdesc || "Understand customer demographics",
        icon: <FaUserFriends className="report-icon" />,
      },
      subReports: [
        t.activecustomers || "Active Customers",
        t.inactivecustomers || "Inactive Customers",
        t.customcustomerreport || "Custom Customer Report",
      ],
    },
    {
      main: {
        name: t.supportticketreport || "Support Ticket Report",
        description: t.supportticketreportdesc || "Monitor support tickets",
        icon: <FaLifeRing className="report-icon" />,
      },
      subReports: [
        t.opentickets || "Open Tickets",
        t.pendingtickets || "Pending Tickets",
        t.resolvedtickets || "Resolved Tickets",
        t.customsupportreport || "Custom Support Report",
      ],
    },
    {
      main: {
        name: t.financialreport || "Financial Report",
        description: t.financialreportdesc || "Overview of financial metrics",
        icon: <FaDollarSign className="report-icon" />,
      },
      subReports: [
        t.revenuereport || "Revenue Report",
        t.expensereport || "Expense Report",
        t.profitanalysis || "Profit Analysis",
        t.customfinancialreport || "Custom Financial Report",
      ],
    },
  ];

  const handleMainClick = (mainReportName) => {
    console.log(`${mainReportName} clicked!`);
    // Add routing or modal logic here.
  };

  const handleSubClick = (subReportName) => {
    console.log(`${subReportName} clicked!`);
    if (subReportName === (t.taskreport || "Task Report")) {
      navigate(`/reports/task/analytics`);
    } else if (subReportName === (t.weeklytargets || "Weekly Targets")) {
      navigate(`/reports/targets/week`);
    } else if (subReportName === (t.monthlytargets || "Monthly Targets")) {
      navigate(`/reports/targets/monthly`);
    } else if (subReportName === (t.annualtargets || "Annual Targets")) {
      navigate(`/reports/targets/annual`);
    }
    // Add navigation or further actions here.
  };

  return (
    <div className="report-menu-wrapper">
      {reportSections.map((section, index) => (
        <div key={index} className="report-section">
          <div
            className="report-main"
            onClick={() => handleMainClick(section.main.name)}
          >
            <div className="report-main-icon">{section.main.icon}</div>
            <div className="report-main-text">
              <h3>{section.main.name}</h3>
              <p>{section.main.description}</p>
            </div>
          </div>
          <hr className="divider" />
          <div className="report-subitems">
            {section.subReports.map((sub, idx) => (
              <span
                key={idx}
                className="report-subitem"
                onClick={() => handleSubClick(sub)}
              >
                {sub}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReportMenu;
